<template>
    <div>
        <div>
            <label>{{$t('label.top_users_chart')}}</label>
        </div>
      <div id="core_users_chart" class="container-fluid">
        <div class="row" v-if="core_loading">
          <div class="col-md-12 card bg-white my-4">
            <div class="history-chart card bg-white d-flex flex-row align-items-center justify-content-center">
              <div class="text-center mx-3">
                {{ $t('datatable.records.processing') }}
              </div>
                <div class="spinner-border text-info" role="status">
                  <span class="sr-only"></span>
                </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-md-12 card bg-white my-4">
            <div class="history-chart card bg-white">
              <div ref="chart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ApexCharts from "apexcharts";
import { reportService } from '@/common/api.service'
import Label from "@/components/elements/form/label.vue";
import { topUsersLineOptions } from "@/constants/ApexChartOptions";
export default {
  name: "coreTopUsersChart",
    components: {Label},
    props: {
        query: {
            type: Object,
            required: true
        }
    },
  data() {
    return {
      date_axis: [],
      usersOne: [],
      userTwo: [],
      userThree: [],
      userFour: [],
      userFive: [],
        users: [],
      core_loading: true,
    };
  },
  async mounted() {
    await reportService.fetchCoreTopUsers(this.query)
      .then((res) => {
        this.date_axis = res.data.data.date_axis;
        this.users = res.data.data.user_axis;
        // this.usersOne = res.data.data.user_axis[0];
        // this.userTwo = res.data.data.user_axis[1];
        // this.userThree = res.data.data.user_axis[2];
        // this.userFour = res.data.data.user_axis[3];
        // this.userFive = res.data.data.user_axis[4];
        this.core_loading = false;
      })
      .catch((e) => {
        console.log(e);
      });

    let series = [];

      for (let i= 0; i < this.users.length; i++) {
          series.push({
              name: this.users[i].user_name || "-",
              data: this.users[i].total_per_days,
          })
      }

    await this.$nextTick();
    // the chart container only exists once loading finished
    if (!this.$refs.chart) {
      return;
    }
    this.chart = new ApexCharts(this.$refs.chart, topUsersLineOptions(series, this.date_axis));
    this.chart.render();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
};
</script>

<style scoped>
.history-chart {
  width: 100%;
  margin: 0.7rem auto;
}
</style>
